const denialReasons = Object.freeze({
   ISSUE_CLOSED: 'ISSUE_CLOSED',
   FRAME_NOT_FOUND: 'FRAME_NOT_FOUND',
   NOT_OWNER: 'NOT_OWNER',
   READ_ONLY: 'READ_ONLY',
   ALREADY_DELETED: 'ALREADY_DELETED'
});

function firstDefined(...values) {
   return values.find((value) => value !== undefined && value !== null);
}

function normalizeId(value) {
   return value == null ? null : String(value);
}

function frameOwnerId(frame = {}) {
   const contentUser = frame.content && frame.content.user;
   const messageUser = frame.user;
   return firstDefined(
      frame.noUser,
      contentUser && contentUser.noUser,
      contentUser && contentUser.idUser,
      contentUser && contentUser._id,
      contentUser && contentUser.id,
      messageUser && messageUser.noUser,
      messageUser && messageUser.idUser,
      messageUser && messageUser._id,
      messageUser && messageUser.id
   );
}

function isReadOnly(frame = {}) {
   return Boolean(frame.readOnly === true || frame.isReadonly === true || (frame.meta && frame.meta.isReadonly === true));
}

function evaluateDurableRules({ frame, actorId }) {
   if (!frame) return { allowed: false, reason: denialReasons.FRAME_NOT_FOUND };
   if (frame.deleted === true) return { allowed: false, reason: denialReasons.ALREADY_DELETED };
   if (isReadOnly(frame)) return { allowed: false, reason: denialReasons.READ_ONLY };
   if (normalizeId(frameOwnerId(frame)) !== normalizeId(actorId)) {
      return { allowed: false, reason: denialReasons.NOT_OWNER };
   }
   return { allowed: true, reason: null };
}

function evaluateActionTime({ isIssueClosed, frame, actorId }) {
   if (isIssueClosed === true) return { allowed: false, reason: denialReasons.ISSUE_CLOSED };
   return evaluateDurableRules({ frame, actorId });
}

function evaluateReplayTime({ frame, actorId }) {
   return evaluateDurableRules({ frame, actorId });
}

module.exports = {
   denialReasons,
   evaluateActionTime,
   evaluateReplayTime,
   canDeleteAtActionTime: (input) => evaluateActionTime(input).allowed,
   canDeleteAtReplayTime: (input) => evaluateReplayTime(input).allowed
};
